import React, { useState } from 'react';
import styled from 'styled-components';
import { rgba } from 'polished';
import DatePicker from 'react-date-picker';
import { Controller } from 'react-hook-form';
import {
  FaAngleLeft,
  FaAngleDoubleLeft,
  FaAngleRight,
  FaAngleDoubleRight,
} from 'react-icons/fa';

import Label, { FieldWrapper } from './Label';
import ErrorMessage from './ErrorMessage';
import { useFormContext } from './formUtils';

const DateField = ({ name, fieldOptions }) => {
  const required =
    fieldOptions && fieldOptions.required ? fieldOptions.required : false;
  const halfWidth =
    fieldOptions && fieldOptions.halfWidth ? fieldOptions.halfWidth : false;
  const description =
    fieldOptions && fieldOptions.description ? fieldOptions.description : false;
  const adminLabel =
    fieldOptions && fieldOptions.adminLabel ? fieldOptions.adminLabel : false;
  const fieldName = adminLabel ? adminLabel : name;

  const { errors, control } = useFormContext();
  const error = errors[fieldName];

  const [focused, setFocus] = useState(false);
  const handleFocus = e => {
    setFocus(true);
  };
  const handleBlur = e => {
    if (e[0].target.tagName === 'INPUT') {
      if (!e[0].target.value) {
        setFocus(false);
      }
    }
  };

  return (
    <FieldWrapper halfWidth={halfWidth} className="date-field-wrapper">
      <DateTimeLabel
        className="field-text"
        isFocused={focused}
        htmlFor={fieldName}
        halfWidth={halfWidth}
      >
        <span className="label-text">
          {name}
          {required && '*'}
        </span>
        <Controller
          as={DatePicker}
          control={control}
          rules={{ required }}
          className="text-input date-field"
          name={fieldName}
          onFocus={handleFocus}
          onBlur={handleBlur}
          prevLabel={<FaAngleLeft />}
          prev2Label={<FaAngleDoubleLeft />}
          nextLabel={<FaAngleRight />}
          next2Label={<FaAngleDoubleRight />}
        />
      </DateTimeLabel>
      {description && <p className="field-description">{description}</p>}
      {error && <ErrorMessage className="error--date-field" {...error} />}
    </FieldWrapper>
  );
};

const DateTimeLabel = styled(Label)`
  .react-date-picker {
    width: 100%;
    height: 100%;
    display: flex;
    padding: 1rem;
    &__wrapper {
      border: 0;
    }
    &__inputGroup {
      /* display: flex;
      align-items: center;
      justify-content: flex-start; */
      transition: 0.25s;
      opacity: ${({ isFocused }) => (isFocused ? 1 : 0)};
      &__input {
        flex: 1 0 auto;
        padding: 0;
        :invalid {
          background: transparent;
        }
      }
      &__divider {
        margin: 0 .5rem;
      }
      &__leadingZero {
        margin: .5rem;
      }
      &__year {
        flex: 2 0 auto;
        /* padding: 0 .5rem; */
      }
    }
    &__button {
      :enabled:hover .react-date-picker__button__icon,
      :enabled:focus .react-date-picker__button__icon {
        stroke: ${({ theme }) => theme.orange};
      }
    }
  }
  
  input {
    margin-top: 0;
    letter-spacing: 0.9px;

  }

  .react-calendar  {
    &__tile {
      font-family: ${({ theme }) => theme.font.heading};
      font-weight: ${({ theme }) => theme.font.bold};
      font-size: 1.3rem;
      &--now {
        background: white;
        :enabled:hover {
          background: white;
        }
      }
      &--active {
        background: ${({ theme }) => theme.orange};
        color: white;
        :enabled:hover {
          background: ${({ theme }) => theme.orange};
        }
      }
      &--hasActive {
        background: ${({ theme }) => theme.orange};
        color: white;
        :enabled:hover {
          background: ${({ theme }) => theme.orange};
        }
      }
    }

    &__month-view {
      &__days {
        &__day {
          /* color: ${({ theme }) => theme.dark}; */
          &--weekend {
            color: ${({ theme }) => theme.orange};
            &.react-calendar__tile--active {
              color: white;
            }
          }
          &--neighboringMonth {
            color: ${({ theme }) => rgba(theme.black, 0.5)};
          }
        }
      }
      &__weekdays {
        &__weekday {
          font-family: ${({ theme }) => theme.font.heading};
          font-weight: ${({ theme }) => theme.font.bold};
          font-size: 1.3rem;
          text-transform: uppercase;
        }
      }
    }
    &__navigation {
      /* background: ${({ theme }) => theme.orange}; */
      button {
        background: ${({ theme }) => theme.orange};
        transition: .25s;
        :enabled:hover {
          background: ${({ theme }) => rgba(theme.orange, 0.9)};
        }
      }
      &__label {
        font-family: ${({ theme }) => theme.font.heading};
        font-weight: ${({ theme }) => theme.font.bold};
        font-size: 1.3rem;
        text-transform: uppercase;
        color: white;
        /* color: ${({ theme }) => theme.dark}; */
      }
      &__arrow {
        color: white;
      }
    }
  }
  
`;

export default DateField;
